import { useMemo } from 'react';
import { defaultRoutesByPermission } from '@/routes/config';
import { usePermissions } from '@/context/PermissionContext';

/**
 * Returns the default route the user has permission for.
 * If no matching permissions are found, it returns '/my-information' as a fallback.
 * @returns The default route the user has permission for.
 */
export function useRouteWithPermission() {
  const { permissions } = usePermissions();

  const routeWithPermission = useMemo(() => {
    for (const { path, scope } of defaultRoutesByPermission) {
      if (permissions.has(scope)) return path;
    }

    return '/my-information';
  }, [permissions]);

  return routeWithPermission;
}
